import { QuestionTypeOption } from 'src/common/components/QuestionTypeFactory/types';

export const FETCH_RISK_ASSESSMENT_QUESTIONS = `
query Query {
  fetchRiskAssessmentQuestions
}
`;

export const QUESTIONS: QuestionItem[] = [
  {
    text: 'What is your something?',
    type: 'CUSTOM',
    subText: '',
    options: [],
    parent: {},
    id: '1',
    attributeKey: 'something_some2',
    source: 'tifin-personality',
  },
  // {
  //   text: 'What is your something?',
  //   type: 'SLIDER',
  //   options: [],
  //   // parent: {},
  //   id: '1',
  //   attributeKey: 'something_some2',
  //   },
  // {
  //   text: 'What is your something 2?',
  //   type: 'RADIO',
  //   attributeKey: 'something_some2',
  //   options: ['YES', 'NO'],
  //   // parent: {},
  // },
  // {
  //   text: 'What is your something 3?',
  //   type: 'GROUPED_CHECKBOX',
  //   attributeKey: 'something_some3',
  //   options: ['OPTION 1', 'OPTION 2', 'OPTION 3'],
  //   parent: {
  //     tab1: ['OPTION 1', 'OPTION 2', 'OPTION 3'],
  //     tab2: ['OPTION 4', 'OPTION 5', 'OPTION 6'],
  //     tab3: ['OPTION 7', 'OPTION 8', 'OPTION 9'],
  //   },
  // },
  // {
  //   text: 'What is your something 3?',
  //   type: 'GROUPED_RADIO',
  //   attributeKey: 'something_some2',
  //   options: ['OPTION 1', 'OPTION 2', 'OPTION 3'],
  //   parent: {
  //     tab1: ['OPTION 1', 'OPTION 2', 'OPTION 3'],
  //     tab2: ['OPTION 4', 'OPTION 5', 'OPTION 6'],
  //     tab3: ['OPTION 7', 'OPTION 8', 'OPTION 9'],
  //   },
  // },
  // {
  //   text: 'What is your something 3?',
  //   attributeKey: 'something_some',
  //   type: 'GROUPED_CHECKBOX',
  //   options: ['OPTION 1', 'OPTION 2', 'OPTION 3'],
  //   parent: {
  //     tab1: ['OPTION 1', 'OPTION 2', 'OPTION 3'],
  //     tab2: ['OPTION 4', 'OPTION 5', 'OPTION 6'],
  //     tab3: ['OPTION 7', 'OPTION 8', 'OPTION 9'],
  //   },
  // },
  // {
  //   text: 'Please enter your personal details.',
  //   attributeKey: 'personal_stuff',
  //   type: 'CUSTOM',
  //   options: [],
  //   // parent: {},
  // },
  // {
  //   text: 'Please enter address.',
  //   attributeKey: 'personal_stuff',
  //   type: 'CUSTOM',
  //   options: [],
  //   // parent: {},
  // },
];

export type QuestionItem = {
  id: string;
  text: string;
  subText: string;
  type: string;
  attributeKey: string;
  options: TempOptionObject[];
  source: string;
  metadata?: any;
  parent: {
    [key: string]: string[];
  };
};

export type TransformedQuestionItem = Omit<
  QuestionItem,
  'options' | 'text' | 'attributeKey'
> & {
  attributeKey: string;
  options: QuestionTypeOption[];
  label: string;
  questionId: string;
};

const transformQuestionItem = ({
  id,
  value,
  label,
  parent,
  imageTitle,
}: TempOptionObject): QuestionTypeOption => ({
  id,
  label,
  value,
  imageTitle,
  parentCategory: parent,
});

const transformGroupedOptions = (dataObject: any) => {
  const values = Object.values(dataObject).reduce(
    (finalOptions: any[], item: any) => {
      const { value, options } = item;
      const optionsMappedWithParent = options.map(option => ({
        ...option,
        parentCategory: value,
      }));
      return finalOptions.concat(optionsMappedWithParent);
    },
    [],
  );
  return values;
};

type TempOptionObject = {
  id?: string;
  parent?: string;
  value: string;
  label: string;
  cause?: string;
  imageTitle?: string;
};

export const transformQuestions = (questions: QuestionItem[]) =>
  questions
    .filter(({ type }) => type !== 'Theme Selection')
    .map(question => {
      // const parentKeys = Object.keys(question.parent);
      // if (parentKeys.length) {
      //   const options: TempOptionObject[] = parentKeys.reduce(
      //     (allOptions, item) => {
      //       const nestedOptions = question.parent[item].map(v => ({
      //         parent: item,
      //         value: v,
      //       }));
      //       return (allOptions as any).concat(nestedOptions);
      //     },
      //     [],
      //   );
      //   return {
      //     label: question.question,
      //     type: question.type,
      //     options: options.map(option => transformQuestionItem(option)),
      //   };
      // }
      return {
        questionId: question.id,
        label: question.text,
        subText: question.subText,
        type: question.type,
        attributeKey: question.attributeKey,
        source: question.source,
        metadata: question.metadata ?? undefined,
        options:
          question.type === 'GROUPED_CHECKBOX'
            ? transformGroupedOptions(question?.options)
            : question?.options && Array.isArray(question?.options)
            ? question?.options.map(option =>
                transformQuestionItem({
                  id: option?.id ?? '',
                  value: option.value,
                  label: option.label ?? option?.cause ?? '',
                  parent: option?.parent ?? '',
                  imageTitle: option.imageTitle ?? '',
                }),
              )
            : [],
      };
    });
